module.exports = __webpack_public_path__ + "static/practice-07-cover-511d8878f80901722c6d464ce2baf8eb.jpg";